<template>
  <div>
    <UiPageHeader>
      <template #default>{{ $t('contacts') }}</template>
      <template #page-specific-content>
        <div class="tw-flex tw-flex-1 tw-justify-between tw-gap-6 tw-items-center">
          <tooltip-select tip="_contacts" class="tw-ml-2"></tooltip-select>
          <div class="tw-flex tw-items-center tw-gap-4">
            <download-button
              :data="contacts"
              label="Download Contacts"
              fileNamePrefix="contacts"
              :headers="exportHeaders"
              :headerMapping="exportHeaderMapping"
              @download-complete="onDownloadComplete"
              iconClass="tw-text-primary-300 hover:tw-text-primary-400"
            />
            <create-contact :refresh="refresh" v-if="checkScope(scopeLiterals.ContactsCreate)" />
            <v-menu offset-y>
              <v-btn slot="activator" color="secondary" dark :small="true" colo class="secondary">
                {{ $tc('_action', 2) }}
                <i class="material-icons"> arrow_drop_down </i>
              </v-btn>
              <v-list>
                <v-list-tile v-if="checkScope(scopeLiterals.ContactsUpdate)">
                  <v-list-tile @click="disableAll()">
                    <v-list-tile-title>Disable All</v-list-tile-title>
                  </v-list-tile>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </div>
      </template>
    </UiPageHeader>
    <div class="tw-py-4 tw-px-6">
      <contacts ref="contactsRef" />
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag';

import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import DownloadButton from '../../components/common/DownloadButton.vue';
import Contacts from '../../components/company/Contacts.vue';
import CreateContact from '../../components/CreateContact.vue';

export default {
  props: [],
  components: {
    Contacts: Contacts,
    CreateContact,
    UiPageHeader,
    DownloadButton,
  },
  data() {
    return {
      // Export headers for CSV download
      exportHeaders: [
        'id',
        'name',
        'enabled',
        'remoteId',
        'accountingConnectionId',
        'source',
        'defaultRevenueCategory',
        'defaultExpenseCategory',
        'addresses',
      ],
      // Header mapping for CSV download
      exportHeaderMapping: {
        id: 'ID',
        name: 'Name',
        enabled: 'Enabled',
        remoteId: 'Remote ID',
        accountingConnectionId: 'Accounting Connection ID',
        source: 'Source',
        defaultRevenueCategory: 'Default Revenue Category',
        defaultExpenseCategory: 'Default Expense Category',
        addresses: 'Addresses',
      },
    };
  },
  computed: {
    contacts() {
      return this.$store.getters['contacts/CONTACTS'] || [];
    },
  },
  methods: {
    onDownloadComplete() {
      console.log('Contacts download completed');
      // You can add additional logic here if needed, such as showing a notification
    },
    refresh() {
      this.$refs.contactsRef.refresh();
    },
    async disableAll() {
      const vars = {
        orgId: this.$store.state.currentOrg.id,
      };

      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation ($orgId: ID!) {
              disableContacts(orgId: $orgId) {
                success
              }
            }
          `,
          // Parameters
          variables: vars,
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
